const RANKING = [
  { rank: 1, title: '范马刃牙 — 父子决战', chapter: '全卷完', heat: '🔥 本周最热', badge: 'TOP 1' },
  { rank: 2, title: '刃牙II — 死囚篇', chapter: '全卷完', heat: '经典必读', badge: '' },
  { rank: 3, title: '刃牙道 — 宫本武藏篇', chapter: '全卷完', heat: '口碑封神', badge: '' },
  { rank: 4, title: '相扑道', chapter: '连载中', heat: '最新篇章', badge: 'NEW' },
  { rank: 5, title: '刃牙外传 — 花山薰', chapter: '连载中', heat: '人气角色', badge: '' },
  { rank: 6, title: '刃牙 — 地下竞技场篇', chapter: '全卷完', heat: '入坑首选', badge: '' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[700px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-2">
          热门排行
        </h2>
        <p className="text-foreground-600 text-sm md:text-base text-center mb-10">
          刃牙漫画读者最喜爱的系列排名
        </p>

        <div className="space-y-2">
          {RANKING.map((item) => (
            <div
              key={item.rank}
              className={`flex items-center gap-3 md:gap-4 p-3 md:p-4 rounded-xl border transition-colors cursor-pointer ${
                item.rank === 1
                  ? 'bg-primary-50 border-primary-200/60 hover:border-primary-300'
                  : 'bg-background-50 border-background-200/80 hover:border-primary-200/60'
              }`}
            >
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 font-bold text-sm ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 truncate">
                    {item.title}
                  </h3>
                  {item.badge && (
                    <span className={`px-1.5 py-0.5 rounded text-[10px] font-bold whitespace-nowrap ${
                      item.badge === 'TOP 1' ? 'bg-accent-500 text-background-50' : 'bg-accent-100 text-accent-800'
                    }`}>
                      {item.badge}
                    </span>
                  )}
                </div>
                <span className="text-xs text-foreground-500">{item.chapter}</span>
              </div>
              <span className="text-xs text-foreground-600 whitespace-nowrap flex-shrink-0">{item.heat}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}